import React from 'react'
import config from 'config'

import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/styles'
import { ProductTypes } from '@/modules/base/util/constants'

const androidRegex = new RegExp('Android', 'i')
const iosRegex = new RegExp('iPhone|iPad|iPod', 'i')

/**
 * Checks if the current user agent seems to identify as a mobile device
 * @returns {boolean}
 */
export const isMobileDevice = () => {
  const mobileDevices = [
    'Android',
    'webOS',
    'iPhone',
    'iPad',
    'iPod',
    'BlackBerry',
    'Windows Phone',
  ]

  const regex = new RegExp(mobileDevices.join('|'), 'i')

  return regex.test(navigator.userAgent)
}

export const isMobileScreen = (theme = useTheme()) => {
  return useMediaQuery(theme.devices.mobile)
}

export const isTabletScreen = (theme = useTheme()) => {
  return useMediaQuery(theme.devices.tablet)
}

export const isAndroid = () => {
  return typeof navigator !== 'undefined' && androidRegex.test(navigator.userAgent)
}

export const isIos = () => {
  return typeof navigator !== 'undefined' && iosRegex.test(navigator.userAgent)
}

const androidLinks = {
  main: config.playStoreUrl,
  document: config.playStoreDocumentUrl,
}

const appStoreLinks = {
  main: config.iTunesUrl,
  document: config.appStoreDocumentUrl,
}

export const getStoreLink = (device = null, productType = ProductTypes.MAIN) => {
  if (device === 'ios') {
    return appStoreLinks[productType]
  } else if (device === 'android') {
    return androidLinks[productType]
  }

  if (isAndroid()) {
    return androidLinks[productType]
  } else if (isIos()) {
    return appStoreLinks[productType]
  } else {
    return ''
  }
}

export const getStoreName = () => {
  if (isAndroid()) {
    return 'Play-Store'
  } else if (isIos()) {
    return 'App-Store'
  } else {
    return ''
  }
}

export const withMobileScreen = (WrapperComponent) => {
  return (props) => <WrapperComponent {...props} isMobileScreen={isMobileScreen()} />
}
